import { Component ,AfterViewInit, HostListener} from '@angular/core';
declare var $: any; 
@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css']
})
export class PackageComponent implements AfterViewInit{



  showPolicyModal:boolean=false
  showRefundModal:boolean=false
  showTermsModal:boolean=false


  openTermsModal(){
    this.showTermsModal = true;
  }
  openRefundModal(){
    this.showRefundModal = true;
  }
  openPolicyModal(){
    this.showPolicyModal = true;
  }

  closeTermsModal() {
    this.showTermsModal = false;
  }
  closePolicyModal() {
    this.showPolicyModal = false;
  }
  closeRefundModal() {
    this.showRefundModal = false;
  }
    isNavOpen = false;

  // navTog button click → toggle
  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  // Link click pe close
  closeNav(): void {
    this.isNavOpen = false;
  }

  // Nav ke bahar click pe close
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.unav')) {
      this.isNavOpen = false;
    }
  }
  ngAfterViewInit(): void {
    
    
    
  }
}
